import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, normalBackPackSaveI } from "../../manager/DefineInterface";
import BackpackPrefab from "./BackpackPrefab";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BackpackItem extends cc.Component {
    @property({ type: cc.Label, displayName: "名字" })
    itemName: cc.Label = null;

    @property({ type: cc.Label, displayName: "数量" })
    itemNum: cc.Label = null;

    @property({ type: cc.Node, displayName: "图片" })
    icon: cc.Node = null;

    @property({ type: cc.Button, displayName: "按钮" })
    btn: cc.Button = null;

    @property({type:cc.Node,displayName:"选择节点"})
    selectNode:cc.Node = null;

    @property({type:cc.Node,displayName:"出售中节点"})
    outSellNode:cc.Node = null;

    moveFun:(e:cc.Event.EventTouch)=>void

    backPrefab:BackpackPrefab = null;
    
    goodsConfig:NormalBackpackI = null;

    goodsID: number = 0;

    backpackItem: normalBackPackSaveI;

    onLoad(){
        this.node.on("touchstart",this.onTouchStart,this);
        this.node.on("touchend",this.onTouchEnd,this);
        this.node.on('touchcancel',this.onTouchCancel,this);
    }

    startTouchTime:number = 0;

    onTouchStart(e:cc.Event.EventTouch){
        this.icon.scale = 1.05;
        let now = Date.now();
        this.startTouchTime = now;
        this.scheduleOnce(this.onTouchLongPress,0.5);
    }

    onTouchEnd(e:cc.Event.EventTouch){
        this.touchEndNormal();
        let now = Date.now();
        if(now - this.startTouchTime < 500){
            this.onTouchClick();
        }

    }

    onTouchCancel(e:cc.Event.EventTouch){
        this.touchEndNormal();
    }

    touchEndNormal(){
        this.icon.scale = 1;
        this.unschedule(this.onTouchLongPress);
        this.node.off("touchmove",this.onTouchMove);
        this.hideExplain();
    }

    onTouchMove(e:cc.Event.EventTouch){
        
    }

    //长按
    onTouchLongPress(){
        // 展示描述信息
        this.showExplain();
        this.node.on("touchmove",this.onTouchMove,this);
    }

    //点击
    onTouchClick(){
        // 展示用途
        this.backPrefab.showUseBtns(this);
    }


    bindData(backpackItem: normalBackPackSaveI, backpackPrefab:BackpackPrefab,moveFun:(e:cc.Event.EventTouch)=>void) {
        this.moveFun = moveFun;
        this.backPrefab = backpackPrefab;
        this.backpackItem = backpackItem;
        let goodsItem = backPackEventMap()[backpackItem.backId];
        this.goodsConfig = goodsItem;
        this.goodsID = goodsItem.id;
        this.itemName.string = goodsItem.name;
        
        this.icon.getComponent(cc.Sprite).spriteFrame = null;
        this.loadSprite();
        this.refreshCount();
        if(backpackItem.isSell){
            this.outSellNode.active = true;
        }else{
            this.outSellNode.active = false;
        }
    }

    refreshCount() {
        this.itemNum.string = data_control.getNumberFormat(this.backpackItem.num);
    }

    showExplain(){
        // this.backPrefab.showExplain(this);
    }

    hideExplain(){
        this.backPrefab.hideExplain();
    }

    onClick() {
        // O1HD.emit(BackpackPrefab.CHOOSE_GOODS_FINISH, v2, this.goodsID)
    }

    loadSprite(){
        let spPath:string = this.goodsConfig.spPath;
        if(spPath && spPath != ""){
            getOneBundleByInstant(BUNDLE_SMALL_NAME.backPackGameBundle).load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                if(err){
                    console.log("加载背包图片失败",err);
                }else{
                    if(this.icon && this.icon.isValid){
                        this.icon.getComponent(cc.Sprite).spriteFrame = spr;
                    }
                }
            });
        }
    }
}
